<fl-impersonation-banner></fl-impersonation-banner>

@if ((showClientNotifications$ | async) && (hasActiveClientNotifications$ | async)) {
  <fl-client-notifications-banner></fl-client-notifications-banner>
}

@if (requests$ | async | hasAny) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (notFound$ | async) {
  <fl-blank-layout-container>
    <fl-four-oh-four></fl-four-oh-four>
  </fl-blank-layout-container>
}

@if (notFound$ | async | none) {
  <router-outlet></router-outlet>
}

<fl-investor-bulk-email-progress></fl-investor-bulk-email-progress>
